export class UtilStorage {
    /**
     * Set a value in localStorage with a specified TTL (Time To Live).
     *
     * @param key - The key under which to store the value.
     * @param value - The value to store.
     * @param ttl - Time to live in milliseconds. Default is one day.
     * @param storage
     */
    static set(key, value, ttl = 86400000, storage) {
        const expiryTime = Date.now() + ttl;
        const data = { value, expiryTime };
        storage.setItem(key, JSON.stringify(data));
    }
    /**
     * Get a value from localStorage if it hasn't expired.
     *
     * @param key - The key of the value to retrieve.
     * @param storage
     * @returns The stored value or null if it has expired or doesn't exist.
     */
    static get(key, storage) {
        const item = storage.getItem(key);
        if (!item)
            return null;
        const data = JSON.parse(item);
        if (Date.now() > data.expiryTime) {
            UtilStorage.delete(key, storage);
            return null;
        }
        return data.value;
    }
    /**
     * Delete a value from localStorage.
     *
     * @param key - The key of the value to delete.
     * @param storage
     */
    static delete(key, storage) {
        storage.removeItem(key);
    }
    /**
     * Check if a key exists in localStorage and hasn't expired.
     *
     * @param key - The key to check.
     * @param storage
     * @returns True if the key exists and hasn't expired, false otherwise.
     */
    static isSet(key, storage) {
        const item = storage.getItem(key);
        if (!item)
            return false;
        const data = JSON.parse(item);
        if (Date.now() > data.expiryTime) {
            UtilStorage.delete(key, storage);
            return false;
        }
        return true;
    }
}
